module.exports = __webpack_public_path__ + "static/media/s6.5d1f884e.png";